import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import { LevelEditor } from './components/editor/LevelEditor'
import './index.css'
import './editor.css'

// Using HashRouter for itch.io and static hosting compatibility
// To use BrowserRouter for server deployments: import BrowserRouter and change line below
const Router = HashRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/leveleditor" element={<LevelEditor />} />
      </Routes>
    </Router>
  </React.StrictMode>,
)
